import { motion, useReducedMotion } from "framer-motion";
import { FondoVideoAmbient } from "../../shared";
import { Estrellas, Cohete, Planeta } from "./Ilustraciones";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="kx-portada" data-testid="kx-portada">
      <Estrellas />
      <div className="kx-portada-texto">
        <motion.p className="kx-portada-frase" {...entrar(0.1)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <div className="kx-portada-fila">
          <motion.h1 className="kx-portada-nombre" data-testid="kx-nombre" {...entrar(0.25)}>
            {protagonista.nombre}
          </motion.h1>
          {protagonista.edad && (
            <motion.div {...entrar(0.4)}>
              <Planeta numero={protagonista.edad} texto={protagonista.textoEdad || "años"} />
            </motion.div>
          )}
        </div>
        <motion.p className="kx-portada-fecha" data-testid="kx-fecha" {...entrar(0.55)}>
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p className="kx-portada-mensaje" {...entrar(0.68)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a href="#kx-contenido" className="kx-boton" data-testid="kx-boton-bajar" {...entrar(0.8)}>
            {protagonista.textoBotonEntrada}
          </motion.a>
        )}
      </div>
      <motion.div className="kx-portada-visual" {...entrar(0.5)}>
        <div className="kx-portada-escotilla">
          {datos.portadaVideo?.urlYoutube ? (
            <FondoVideoAmbient
              urlYoutube={datos.portadaVideo.urlYoutube}
              poster={datos.portadaVideo.poster || fotos.portada}
            />
          ) : (
            <img
              className="kx-portada-foto"
              src={fotos.portada}
              alt={`Fotografía de la fiesta de ${protagonista.nombre}`}
            />
          )}
        </div>
        <Cohete />
      </motion.div>
    </header>
  );
}
